// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2tIP-","title":"Header_title__3rxFz","left":"Header_left__2spOH","clinicName":"Header_clinicName__36RoM"};